<template>
  <div class="page-dnaservice main-page">
    <Menu title="涉外法律服务" :home="true" />

    <div class="container-flex">
      <div class="service-block">
        <router-link to="/service/9" class="service-item ">
          <img src="https://yn.12348.laway.cn/los/art_img/202601/59ae1c28f5df11f0a3c0b4055d0b0812.png" class="block w-full" alt="">
        </router-link>
        <div class="service-item   " @click="toAdvisorys">
          <img src="https://yn.12348.laway.cn/los/art_img/202601/95903ed6f69511f0a3c0b4055d0b0812.png" class="block  w-full" alt="">
        </div>
      </div>
      <div class="list-block">
        <div class="hts">涉外服务</div>
        <div class="list-item-panel">
          <div class="list-item" v-for="(v,index) in services" :key="'foreign'+index">
            <div class="item-content" @click="toLink(v)">
              <div :class="'icon '">
                <img  :src="v.img" alt="" width="100%">
              </div>
              <h2>{{ v.title }}</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="list-block">
        <div class="hts">个人法律服务</div>
        <div class="list-item-panel">

          <div class="list-item" v-for="(v,index) in list" :key="'jeys'+index">

            <div class="item-content" @click="toLink(v)">
              <div :class="'icon icon-' + v.icon">
                <i :class="'iconfont ' + v.img"></i>
              </div>
              <h2>{{ v.title }}</h2>

            </div>
          </div>

        </div>
      </div>
      <div class="list-block">
        <div class="hts">企业法律服务</div>
        <div class="list-item-panel">

          <div class="list-item" v-for="(v,index) in qylist" :key="'jeys'+index">

            <div class="item-content" @click="toLink(v)">
              <div :class="'icon icon-' + v.icon">
                <i :class="'iconfont ' + v.img"></i>
              </div>
              <h2>{{ v.title }}</h2>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { STA, INSTRUMENT_TEMPLATE, EXAM_INQUIRE, FOREIGN_LEGAL_CATEGORIES } from '@/datas/constants/statistics'
import Menu from '@/components/Menu'

export default {
  components: {
    Menu
  },
  data () {
    return {
      services: [
        { title: '涉外法律法规', path: '/foreign-legal-service/regulations', icon: 'yellow', img: 'https://qiniu.laway.cn/publaw/b0ad2088c86511f19d5bfa2800184358.png' },
        { title: '域外法律查询', path: '/foreign-legal-service/overseas-law', icon: 'orange', img: 'https://qiniu.laway.cn/publaw/c400eb4cc86511f19d5bfa2800184358.png' },
        { title: '港澳法律查询', path: '/foreign-legal-service/hk-macao-law', icon: 'purple', img: 'https://qiniu.laway.cn/publaw/a315bdb8c86511f19d5bfa2800184358.png' },
        { title: '典型案例', path: '/foreign-legal-service/cases', icon: 'lightgreen', img: 'https://qiniu.laway.cn/publaw/8d03e716c86511f19d5bfa2800184358.png' },
        { title: '涉外服务动态', path: '/swdynamics', icon: 'blue', img: 'https://qiniu.laway.cn/publaw/bc105738c86511f19d5bfa2800184358.png' }
      ].map((service, index) => ({
        ...service,
        statistics: FOREIGN_LEGAL_CATEGORIES[['regulations', 'overseas-law', 'hk-macao-law', 'cases', 'dynamics'][index]]
      })),
      list: [
        {
          title: '公证服务',
          icon: 'green',
          img: 'icongongzhengbanli',
          path: '/service/2',
        },
        {
          title: '司法鉴定',
          icon: 'blue',
          img: 'iconsifajianding',
          path: '/service/3',
        },
        {
          title: '仲裁服务',
          img: 'iconzhongcai',
          icon: 'lightgreen',
          path: '/service/13',
        },
        {
          title: '律师查询',
          icon: 'lightgreen',
          img: 'iconlvshi',
          path: '/flsearch/1'
        },
        {
          title: '律所查询',
          icon: 'yellow',
          img: 'iconlvsuochaxun',
          path: '/flsearch/2'
        }
      ],
      qylist: [
        {
          title: '企业法律风险体检',
          img: 'iconfazhitijian',
          icon: 'red',
          statistics: EXAM_INQUIRE,
          outerlink: `${this.$store.state.app.appSite}/terminal/exam?code=${this.$store.state.device.point.code}&machineId=${this.$store.state.device.point.no}&clean_enterprise=1`,
        },
        {
          title: '企业法律问题咨询',
          img: 'iconminfadianzixundongtai',
          icon: 'yellow',
          outerlink: `${this.$store.state.app.appSite}/terminal/enterprise/ai?code=${this.$store.state.device.point.code}&machineId=${this.$store.state.device.point.no}`,
          statistics: STA.ENTERPRISE_CONSULT,
        },
        {
          title: '合同文书模版',
          icon: 'orange',
          img: 'iconyunshuhetong',
          isSystem: true,
          statistics: INSTRUMENT_TEMPLATE,
          outerlink: `${this.$store.state.app.appSite}/terminal/doclist?code=${this.$store.state.device.point.code}&machineId=${this.$store.state.device.point.no}`,

        },
      ]
    }
  },
  mounted () {
    this.$root.getStatistics(STA.FOREIGN_LEGAL_SERVICES)

  },
  methods: {
    toLink (v) {
      if (v.statistics) {
        this.$root.getStatistics(v.statistics)
      }
      if (v.path) {
        this.$router.push(v.path)
        return
      }
      if (v.outerlink) {

        window.location.href = v.outerlink
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.page-dnaservice
  .container-flex
    padding 0.2rem 1.8rem
    .service-block
      display flex
      .service-item
        flex 1
        display block
        margin 0 0.15rem
        img
          width 100%
    .list-block
      margin 0.2rem 0
      .hts
        font-size 0.28rem
        font-weight bold
        color #fff
        margin-bottom 0.2rem
        padding-left 0.15rem
      .list-item-panel
        display flex
        flex-wrap wrap
        padding 0 0.3rem
        margin 0 -0.3rem
        .list-item
          width 20%
          margin-bottom 0.1rem
          padding 0.2rem
          color #fff
          .item-content
            border-radius 0.1rem
            display flex
            flex-direction column
            height 2.6rem
            text-align center
            justify-content center
            background rgba(255, 255, 255, 0.2)
            .icon
              width 0.9rem
              height 0.9rem
              margin 0 auto 0.2rem
              border-radius 50%
              line-height 0.9rem
              .iconfont
                font-size 0.4rem
              &.icon-yellow
                background #fc9d0b
              &.icon-yellow1
                background #e3bf6b
              &.icon-blue
                background #3574e5
              &.icon-blue1
                background #758cd0
              &.icon-blue2
                background #6d95d2
              &.icon-red
                background #e55158
              &.icon-lightred
                background #cf7887
              &.icon-purple
                background #8f81e2
              &.icon-orange
                background #ff793f
              &.icon-green
                background #33c339
              &.icon-lightblue
                background #4c89f8
              &.icon-lightgreen
                background #38cf83
              &.icon-orange
                background #ff793f
            h2
              font-size 0.28rem
              color #fff
</style>
